export const PAGE_TITLE = 'Conversed.ai Platform';
